<template>
    <div class="w-h-100" style="background:#fff;">
        <div style="padding:20px;height:90%;">
            <div>
                <el-form :model="formData" :rules="rules" ref="ruleForm" label-width="130px">
                    <el-form-item label="系统logo" prop="logoId">
                        <div class="flex">
                            <el-upload ref="imgUpload1"
                                style="display: inline"
                                :http-request="uploadMethod1"
                                :on-change="handleChange"
                                action="uploadUrl">
                                <div v-if="!imageUrl1" style="width:500px;height:120px;border:1px dashed #ddd;line-height:150px;text-align:center;">
                                    <i class="el-icon-plus" style="font-size:40px;color:#ddd;"></i>
                                </div>
                                <div v-else style="width:500px;height:120px;">
                                    <img class="w-h-100" :src="imageUrl1" alt="">
                                </div>
                            </el-upload>
                            <!-- <div style="margin-left:30px;width:180px;height:60px;" v-if="imageName1">
                                {{imageName1}}
                            </div> -->
                        </div>
                        <div style="color:rgb(183,183,183);">请上传尺寸500*120,大小为100K以下的JPG格式图片</div>
                    </el-form-item>
                    <!-- <el-form-item label="办公地址" prop="title">
                        <el-input placeholder="请输入办公地址" v-model="formData.title" style="width:300px;"></el-input>
                    </el-form-item>
                    <el-form-item label="办公电话" prop="title">
                        <el-input placeholder="请输入办公电话" v-model="formData.title" style="width:300px;"></el-input>
                    </el-form-item>
                    <el-form-item label="站点建设与维护" prop="title">
                        <el-input placeholder="请输入站点建设与维护" v-model="formData.title" style="width:300px;"></el-input>
                    </el-form-item> -->
                    <el-form-item label="版权所有" prop="copyright">
                        <el-input placeholder="请输入版权所有" v-model="formData.copyright" style="width:300px;"></el-input>
                    </el-form-item>
                    <el-form-item label="公众号名称" prop="publicAccounts">
                        <el-input placeholder="请输入公众号名称" v-model="formData.publicAccounts" style="width:300px;"></el-input>
                    </el-form-item>
                    <el-form-item label="公众号二维码" prop="qrCodeId">
                        <div class="flex">
                            <el-upload ref="imgUpload2"
                                style="display: inline"
                                :http-request="uploadMethod2"
                                :on-change="handleChange"
                                action="uploadUrl">
                                <div v-if="!imageUrl2" style="width:150px;height:150px;border:1px dashed #ddd;line-height:150px;text-align:center;">
                                    <i class="el-icon-plus" style="font-size:40px;color:#ddd;"></i>
                                </div>
                                <div v-else style="width:120px;height:120px;">
                                    <img class="w-h-100" :src="imageUrl2" alt="">
                                </div>
                            </el-upload>
                            <!-- <el-upload
                                ref="imgUpload2"
                                :on-success="imgSuccess"
                                :on-remove="imgRemove"
                                :http-request="uploadMethod2"
                                accept="image/gif,image/jpeg,image/jpg,image/png,image/svg"
                                :headers="headerMsg"
                                action="uploadUrl"
                                multiple>
                                <el-button type="primary" icon="el-icon-picture">上传图片</el-button>
                            </el-upload> -->
                            <!-- <div style="margin-left:30px;width:180px;height:60px;" v-if="imageName2">
                                {{imageName2}}
                            </div> -->
                        </div>
                        <div style="color:rgb(183,183,183);">请上传尺寸120*120,大小为100K以下的JPG格式图片</div>
                    </el-form-item>
                </el-form>
            </div>
            <img src="/upload/hrweb/2022-11/shr.png" alt="">
            <div style="width:400px;just-content:flex-end;width:430px;" class='flex just-center'>
                <el-button size="small" type="primary" @click="saveConfig">保 存</el-button>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable prefer-const */
import axios from 'axios'
export default {
    data() {
        return {
            imageUrl1: '',
            imageUrl2: '',
            imageName1: '',
            imageName2: '',
            headerMsg: {},
            formData: {
                logoId: '',
                qrCodeId: '',
                publicAccounts: '',
                copyright: ''
            },
            uploadUrl: '/admin/api/website/attachment',
            rules: {
                // categoryName: [{ required: true, message: '请选择栏目名称', trigger: 'blur' }]
            }
        }
    },
    methods: {
        handleChange () {},
        getXtszInfo () {
            this.$api.website.getXtszList().then(res => {
                if (res.code === 200) {
                    this.formData = res.data
                    this.imageUrl1 = res.data.logoFile.url
                    this.imageUrl2 = res.data.qrCodeFile.url
                    this.imageName1 = res.data.logoFile.name + res.data.logoFile.type
                    this.imageName2 = res.data.qrCodeFile.name + res.data.qrCodeFile.type
                }
            })
        },
        imgSuccess (data) {
            console('success')
            console.log(data)
        },
        imgRemove () {},
        uploadMethod1 (obj) {
            let fd = new FormData()
            fd.append('file', obj.file)
            this.$api.imageConfig.imageUpload(fd).then((res) => {
                if (res.code === 200) {
                    this.$refs.imgUpload1.clearFiles()
                    this.formData.logoId = res.data.id
                    this.imageUrl1 = res.data.url
                    this.imageName1 = res.data.name + res.data.type
                    this.$message({
                        type: 'success',
                        message: '上传成功'
                    })
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                }
            })
        },
        uploadMethod2 (obj) {
            let fd = new FormData()
            fd.append('file', obj.file)
            this.$api.imageConfig.imageUpload(fd).then((res) => {
                if (res.code === 200) {
                    this.$refs.imgUpload2.clearFiles()
                    this.formData.qrCodeId = res.data.id
                    this.imageUrl2 = res.data.url
                    this.imageName2 = res.data.name + res.data.type
                    this.$message({
                        type: 'success',
                        message: '上传成功'
                    })
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                }
            })
        },
        saveConfig () {
            this.$api.website.saveConfig(this.formData).then(res => {
                if (res.code === 200) {
                    this.$message({
                        type: 'success',
                        message: '保存成功'
                    })
                }
            })
        }
    },
    mounted() {
        this.getXtszInfo()
    }
}
</script>

<style scoped lang='less'>

</style>
